<script setup lang="ts">
    import { computed, onMounted } from 'vue';
    import { useTheme } from 'vuetify';
    import { BetStatus } from '@/constants';
    import { BetItem } from '@/models/bet';
    import { dateFormatInUserTimeZone } from '@/helpers';

    // Define props with TypeScript type annotations
    const { title, icon, tableHeight, tableFullHeight, betsTotal } = defineProps<{
        title?: string;
        icon?: string;
        tableHeight: number;
        tableFullHeight: number;
        betsTotal: BetItem[];
    }>();

    const { t } = useI18n();

    onMounted(() => {
        console.log('Component %s mounted.', 'app-eventBetsSidePanel');
    });

    const theme = useTheme();

    const tableMinHeight = computed(() => {
        const maxMinHeight = tableFullHeight - 94 - 16 - 34; // - position, margin and header
        let height = betsTotal.length * 66 + 4; // 4 - extra margin bottom
        height = height > maxMinHeight ? maxMinHeight : height;
        return tableHeight > height ? height : tableHeight;
    });
</script>

<template>
    <v-card elevation="0" style="overflow: hidden; border-radius: 8px">
        <v-card-title class="font14 py-1 pl-4 greyText font-weight-regular">
            <v-icon size="24" :icon="icon" />
            {{ title }}
        </v-card-title>
        <v-card-text class="py-0 pt-3" style="overflow: auto" :style="'max-height: ' + tableHeight + 'px; min-height: ' + tableMinHeight + 'px'">
            <v-row v-for="(item, index) in betsTotal" :key="index" class="px-1" style="height: 66px">
                <v-card :style="theme.name.value === 'dark' ? 'background-color: #323338!important' : ''" class="my-1" elevation="1" width="100%">
                    <v-card-text class="pl-2 py-2 font12">
                        <v-row class="pt-1 pl-7">
                            <v-spacer></v-spacer>
                            {{ dateFormatInUserTimeZone(item.createdAt, 'dd MMM HH:mm:ss') }}
                        </v-row>
                        <v-row :class="theme.name.value === 'dark' ? 'whiteText' : 'black--text'">
                            <v-col style="min-width: 25px; max-width: 25px" class="text-center pl-2 pr-0 pt-0 pb-2">
                                <span class="text-center">
                                    <v-icon v-if="item.orderId" :data-tooltip="t('bet.orderIcon')" :data-tippy-placement="'bottom'" color="grey" size="16" :icon="mdiClipboardClockOutline" />
                                    <v-icon v-else :data-tooltip="t('bet.botIcon')" :data-tippy-placement="'bottom'" class="" color="grey" small dense size="9" :icon="mdiRobotOutline" />

                                    <br />

                                    <v-icon
                                        class=""
                                        :style="
                                            item.statusId === BetStatus.Running
                                                ? 'color: #38761d !important'
                                                : item.statusId === BetStatus.Waiting
                                                  ? 'color: #ff9900 !important'
                                                  : item.statusId === BetStatus.Rejected
                                                    ? 'color: rgba(173,10,10,0.85) !important'
                                                    : ''
                                        "
                                        size="11"
                                        :icon="mdiCircle"
                                        :data-tooltip="
                                            item.statusId === BetStatus.Running
                                                ? t('bet.statusRunning')
                                                : item.statusId === BetStatus.Waiting
                                                  ? t('bet.statusWaiting')
                                                  : item.statusId === BetStatus.Rejected
                                                    ? t('bet.statusRejected')
                                                    : ''
                                        "
                                        :data-tippy-placement="'bottom'"
                                    />
                                </span>
                            </v-col>
                            <v-col :class="theme.name.value === 'dark' ? 'whiteText' : 'blackText'" class="pl-1 pr-0 pt-0 pb-2">
                                <div
                                    data-tooltip-position="left"
                                    :class="item.statusId === BetStatus.Waiting ? 'waiting' : item.statusId === BetStatus.Rejected ? 'text-decoration-line-through' : ''"
                                    v-html="item.eventNameNoTeam"
                                ></div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<style scoped></style>
